(function (M) {
  if (!M) return;
  var d = document, hero = d.querySelector('.nk-hero');
  if (!hero) return;
  M.tag('.nk-hero .logo-top', 'fade', { d: 0.2 });
  M.tag('.nk-hero .g > div:first-child > *', 'up', { d: 0.3, step: 0.1 });
  var prod = d.querySelector('.nk-hero .prod');
  if (prod) { M.tag(prod, 'rise', { d: 0.45 }); prod.classList.add('mo-float'); }
  M.tag('.nk-pts .hd > *', 'up', { step: 0.1 });
  M.tag(M.all('.nk-pts .nk-pt'), 'up', { d: 0.1, step: 0.12 });
  M.count('.nk-pts .nk-pt:first-child .n', '2,000');
  M.tag('.nk-use .ph img', 'left');
  M.tag('.nk-use .g > div:last-child > *', 'up', { step: 0.08 });
  M.tag('.nk-facts .g > div:first-child > *', 'up', { step: 0.08 });
  M.tag('.nk-facts .ph img', 'rise', { d: 0.15 });
  M.tag('.nk-buy .ph img', 'rise');
  M.tag('.nk-buy .g > div:last-child > *', 'right', { d: 0.1, step: 0.08 });
})(window.FJKMotion);
